import { BeautyProfileItem } from 'components/general-settings/beauty-profile-create/beauty-profile-item/BeautyProfileItem'

export const BeautyProfileItemContainer = ({ beautyProfileDetail, errorForm, onChangeForm }) => {
    const copyItems = [...(beautyProfileDetail?.items || [])]

    const setItems = (items) => {
        onChangeForm({ items })
    }

    const onChangeItem = (e) => {
        const { name, value, index } = e
        copyItems[index][name] = value
        setItems(copyItems)
    }

    const onAddNewItem = () => {
        setItems([
            ...copyItems,
            {
                name: null,
                image_url: null,
            },
        ])
    }

    const props = {
        items: copyItems,
        setItems,
        onChangeItem,
        onAddNewItem,
        errorForm,
    }

    return <BeautyProfileItem {...props} />
}
